'use client';

import globalDomains from '@/utils/global-domains';
import {useSearchParams} from 'react-router-dom';

/**
 * 링크를 브릿지(/station/_/bridge?) 사용 링크로 변환합니다.
 * @param link
 */
export const goLinkWithChannelBridge = (link: string) => {
  return `${globalDomains.WWW_AFREECATV}/station/_/bridge?url=${encodeURIComponent(link)}`;
};

/**
 * IOS의 유니버설 링크 동작을 우회하기 위한 리다이렉션 전용 더미 라우트입니다.
 * /station/_/bridge
 * @returns
 */
const ChannelBridge = () => {
  const [params] = useSearchParams();

  const targetUrl = params.get('url') || `${globalDomains.M_AFREECATV}`;

  // Note. 페이지 전환 미발생 시 비동기 함수로 전환 시도
  window.location.replace(targetUrl);
  setTimeout(() => {
    window.location.replace(targetUrl);
  }, 1);

  return null;
};

export default ChannelBridge;
